import React from 'react'
import './invite-existing-students.scss'
import SessionCache from '../../routes/session-cache'
import { Modal, ModalBody } from 'reactstrap'
import { ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import SchoolApi from '../../../apis/school'
import moment from 'moment'

class InviteExistingStudents extends React.Component {
  state = {
    mobileNumber: '',
    email: '',
    isWhatsappInvited: false,
    selectedInviteOptions: []
  }

  constructor(props) {
    super(props)
  }

  onInviteSelected = (value) => {
    const { selectedInviteOptions } = this.state
    const idx = selectedInviteOptions.findIndex(s => s === value)
    if (idx > -1) {
      selectedInviteOptions.splice(idx, 1);
    } else {
      selectedInviteOptions.push(value)
    }
    this.setState({
      selectedInviteOptions
    })
  }

  showToaster(type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster() {
    this.setState({
      showToaster: false
    })
  }

  convertDate = (date, currentFormat = '', requiredFormat = 'DD MMM YYYY') => {
    return moment(date, currentFormat).format(requiredFormat)
  }

  sendInvitation = _ => {
    const { selectedInviteOptions } = this.state
    if (!selectedInviteOptions.length) return
    const { event } = this.props
    let user = SessionCache.getUser()
    let payload = {
      schoolCode: user.schoolInfo.schoolCode,
      schoolName: user.schoolInfo.name,
      // eventName: event?.notificationTitle,
      eventName: `${event?.title}`,
      initialDate: `*${event?.initalDateText}*`,
      finalDate: `*${event?.finalDateText}*`,
      types: selectedInviteOptions,
      eligibleClasses: `Class 6 to Class 9`
    }
    this.setState({
      isInviteSubmit: true
    })
    SchoolApi.sendExistingStudentInvitations(payload)
      .then(response => {
        this.setState({
          isInviteSubmit: false
        })
        // this.props.onClose(true, "Message shared successfully on " + selectedInviteOptions.join(", "))
        this.showToaster("info", "Message shared successfully on " + selectedInviteOptions.join(", "))
      })
      .catch(err => {
        this.showToaster('error', 'Something went wrong')
        this.setState({
          isInviteSubmit: false
        })
      })
  }

  render() {
    const {
      toasterMessage,
      toasterType,
      isInviteSubmit,
      showToaster,
      selectedInviteOptions
    } = this.state
    return (
      <Modal
        className='cw-custom-modal'
        isOpen={true}
        toggle={this.props.onClose}
        size={'md'}
      >
        <ModalBody>
          <div className=''>
            <div className='pt-2 pb-4'>
              <span className='text-right'>
                <img
                  className='close-icon cursor-pointer'
                  src={getImageSource(ImageConstants.CROSS)}
                  onClick={this.props.onClose}
                />
              </span>
            </div>
            <div>
              <div className='teachers-list invite-exisiting-teachers'>
                <div className='row'>
                  <div className='col'>
                    <div className='text-center'>
                      <div className='header-text'>
                        SEND INVITE TO STUDENTS
                      </div>
                      <div className='sub-title'>
                        {this.props.event?.title}
                      </div>
                    </div>
                    <div className='mt-5'>
                      <div className='invite-participants center-box'>
                        <div className='row mt-2 my-2 text-center'>
                          <div className='col-6 cursor-pointer invite-options' onClick={_ => this.onInviteSelected("email")}>
                            {selectedInviteOptions.includes("email") ?
                              <img className="rect-box" src={getImageSource(ImageConstants.RECT_TICK)} onClick={() => { this.setState({ selectAll: !this.state.selectAll }) }} /> :
                              <img className="rect-box inactive" src={getImageSource(ImageConstants.RECT)} onClick={() => { this.setState({ selectAll: !this.state.selectAll }) }} />
                            }
                            <span>Email</span>
                          </div>
                          <div className='col-6 cursor-pointer invite-options' onClick={_ => this.onInviteSelected("whatsapp")}>
                            {selectedInviteOptions.includes("whatsapp") ?
                              <img className="rect-box" src={getImageSource(ImageConstants.RECT_TICK)} onClick={() => { this.setState({ selectAll: !this.state.selectAll }) }} /> :
                              <img className="rect-box inactive" src={getImageSource(ImageConstants.RECT)} onClick={() => { this.setState({ selectAll: !this.state.selectAll }) }} />
                            }
                            <span>Whatsapp</span>
                          </div>
                          {/* <div className='col-4 cursor-pointer invite-options' onClick={_ => this.onInviteSelected("sms")}>
                            {selectedInviteOptions.includes("sms") ?
                              <img className="rect-box" src={getImageSource(ImageConstants.RECT_TICK)} onClick={() => { this.setState({ selectAll: !this.state.selectAll }) }} /> :
                              <img className="rect-box inactive" src={getImageSource(ImageConstants.RECT)} onClick={() => { this.setState({ selectAll: !this.state.selectAll }) }} />
                            }
                            <span>SMS</span>
                          </div> */}
                        </div>
                        <div className='row mt-2 my-2 mt-4'>
                          <div className='col text-center'>
                            <button className={selectedInviteOptions.length ? "cw-button-primary cw-button-mod" : "cw-button-disabled"} onClick={() => !isInviteSubmit && selectedInviteOptions.length && this.sendInvitation()}>
                              SEND INVITE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {showToaster ? (
                  <ToasterComponent message={toasterMessage} type={toasterType} position="bottom-center" />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

export default InviteExistingStudents
